import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['input', 'clipboardContainer']

  connect() {
    setTimeout(this.refreshClipboardVisibility.bind(this), 0) // Timeout to wait for any dom changes in progress
  }

  refreshClipboardVisibility() {
    this.toggleClipboard(this.isACheckboxChecked())
  }

  // private

  isACheckboxChecked() {
    return this.inputTargets.some((input) => { return input.checked })
  }

  toggleClipboard(show) {
    if (show) {
      this.clipboardContainerTarget.classList.remove('hidden')
    } else {
      this.clipboardContainerTarget.classList.add('hidden')
    }
  }
}
